module.exports = __webpack_public_path__ + "static/shonda-rhimes-11c790f0a3928d31e46d9bab85f7b3ad.jpg";